module.exports = __webpack_public_path__ + "img/15.83d21ab2.png";